import { useEffect, useState } from 'react';
import { getBbvs } from '../../helpers'
import { Select } from 'antd';

const RecordQuarterSelect = (props) => {

  const { quarter, options, form, field, rowIndex, ...rest } = props

  const [fetching, setFetching] = useState(true)
  const [bbvs, setBbvs] = useState({})

  useEffect(() => {
    (async () => {
      setBbvs(await getBbvs())
      setFetching(false)
    })()
  }, [])

  return (
    fetching
    ?
    <Select
      disabled={true}
      value={undefined}
      loading={fetching}
    />
    :
    <Select
      onSelect={(val) => {
        let formVals = form.getFieldsValue()
        const currentQtr = options.find((option) => option.value === quarter).value
        const existingRecordQtrs = formVals.interventions[rowIndex].records.map(
          ({ bbvq }) => options.find((option) => option.value === bbvq).value)
        const selectedQtr = options.find((option) => option.value === val).value
        formVals.interventions[rowIndex].qname = _.uniq([currentQtr, ...existingRecordQtrs, selectedQtr])
        formVals.interventions[rowIndex].records[field.name].oldValue = bbvs[val]
        form.setFieldsValue(formVals)
      }}
      options={options}
      {...rest}
    />
  );
};

export default RecordQuarterSelect;
